(function () {
  const root = document.querySelector('.sbs-cro');
  if (!root) return;
  const button = root.querySelector('[data-cro-buy-now]');
  const form = root.querySelector('#ProductForm');
  const error = root.querySelector('[data-cro-error]');
  if (!button || !form) return;
  button.addEventListener('click', async function () {
    if (!form.reportValidity()) return;
    button.disabled = true;
    button.textContent = 'Opening checkout…';
    error.hidden = true;
    try {
      const localeRoot = window.Shopify?.routes?.root || '/';
      const response = await fetch(localeRoot + 'cart/add.js', {
        method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Could not add this item. Please try again.');
      window.location.assign(localeRoot + 'checkout');
    } catch (err) {
      error.textContent = err.message || 'Could not open checkout. Please try again.';
      error.hidden = false;
      button.disabled = false;
      button.textContent = 'Buy now';
    }
  });
})();
